/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { ReactivateUsersOptions, ReactivateUsersResponses } from '../types/ReactivateUsers'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Bulk form of POST /v1/user/{user_id}/reactivate. Admin may target tenant_id, trading_challenge_id, or explicit user_ids. COMPETITION_MANAGER may only target one assigned trading_challenge_id and their users (no tenant_id). Each user is processed independently: the response reports, per user, either the REACTIVATED request or the reason it was rejected. Duplicate user IDs collapse into one result.
 * @summary Lift multiple users' account deactivations (admin or scoped competition manager)
 * {@link /v1/user/reactivate}
 */
export function reactivateUsers<ThrowOnError extends boolean = true>(
  options: Options<ReactivateUsersOptions, ThrowOnError>,
): Unwrappable<RequestResult<ReactivateUsersResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/user/reactivate',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ReactivateUsersResponses, ThrowOnError>>,
  )
}
